import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  host: {
    '[class]': 'classes',
    '(click)': 'handleClick()',
  },
})
export class ChipComponent {
  @Input() selected = false;
  @Input() disabled = false;
  @Input() removable = false;
  @Input() selectable = true;
  @Input() color: 'primary' | 'accent' | 'warn' | 'light' = 'primary';
  @Input() size: 'default' | 'small' = 'default';

  @Output() removed = new EventEmitter<void>();
  @Output() clicked = new EventEmitter<void>();

  get classes(): string {
    const classList: string[] = ['chip'];

    if (this.selected) {
      classList.push('chip--selected');
    }

    if (this.disabled) {
      classList.push('chip--disabled');
    }

    if (this.color) {
      classList.push(`chip--${this.color}`);
    }

    if (this.size === 'small') {
      classList.push('chip--small');
    }

    return classList.join(' ');
  }

  handleClick(): void {
    if (!this.disabled && this.selectable) {
      this.clicked.emit();
    }
  }

  handleRemove(event: Event): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.removed.emit();
    }
  }
}
